import { Route } from 'react-router';
import ImpersonationPage from '../../../modules/impersonation';

export const ImpersonateRouter = [
  <Route index element={<ImpersonationPage />} />,
];
